import { reactive } from 'vue'

export default {
  debug: false,

  state: reactive({
    categories: [],
    tags: [],
    search: '',
  }),

  setCategoryAction({ name, id }) {
    if (this.debug) {
      console.log('setCategoryAction triggered with', name)
    }

    this.state.categories = [id]
    // this.state.categories.push(id) // uncomment this line, to allow multiple categories as query paramter
  },

  removeCategoryAction({ name, id }) {
    if (this.debug) {
      console.log('setCategoryAction triggered with', name)
    }

    const index = this.state.categories.indexOf(id)
    if (index > -1) {
      this.state.categories.splice(index, 1)
    }
  },

  setTagAction({ name, id }) {
    if (this.debug) {
      console.log('setTagAction triggered with', name)
    }

    this.state.tags.push(id)
  },

  removeTagAction({ name, id }) {
    if (this.debug) {
      console.log('setTagAction triggered with', name)
    }

    const index = this.state.tags.indexOf(id)
    if (index > -1) {
      this.state.tags.splice(index, 1)
    }
  },

  clearTagsAction() {
    if (this.debug) {
      console.log('clearTagsAction')
    }

    this.state.tags = []
  },

  setSearchTextAction(search) {
    if (this.debug) {
      console.log('setSearchTextAction triggered with', search)
    }

    this.state.search = search
  },

  clearSearchTextAction() {
    if (this.debug) {
      console.log('clearSearchTextAction')
    }

    this.state.search = ''
  }
}
